import NamedDto from 'modules/base/dto/NamedDto';

export class UserEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.email = null;
		/** @type {string} */
		this.password = null;
		/** @type {Date} */
		this.passwordAgain = null;
		/** @type {string} */
		this.registrationStatus = null;
		/** @type {number[]} */
		this.roles = null;
		/** @type {string} */
		this.profilePicture = null;
		/** @type {boolean} */
		this.passwordActive = null;
		/** @type {number[]} */
		this.userGroups = null;
	}

	/**
	 * @typedef {Object} _UserEditDtoProps
	 * @property {string} email
	 * @property {string} password
	 * @property {string} passwordAgain
	 * @property {string} registrationStatus
	 * @property {number[]} roles
	 * @property {string} profilePicture
	 * @property {boolean} passwordActive
	 * @property {number[]} userGroups
	 *
	 * @typedef {import("../NamedDto").NamedDtoProps & _UserEditDtoProps} UserEditDtoProps
	 */
	/**
	 *
	 * @param {UserEditDtoProps} props
	 * @returns {UserEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.email = props.email;
		this.password = props.password;
		this.passwordAgain = props.passwordAgain;
		this.registrationStatus = props.registrationStatus;
		this.roles = props.roles !== null ? props.roles : [];
		this.profilePicture = props.profilePicture;
		this.passwordActive = props.passwordActive;
		this.userGroups = props.userGroups !== null ? props.userGroups : [];
		return this;
	}
}

export default UserEditDto;
